var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDfwInnovators(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 326,
    height: 326,
    viewBox: "0 0 326 326",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M311.005 311.005L15.4769 15.477C10.8343 10.8344 3 14.1713 3 20.6999V316.228C3 320.291 6.33684 323.482 10.254 323.482H305.782C312.311 323.482 315.503 315.648 311.005 311.005Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M311.876 311.877L163.314 163.314L3 323.628H307.088C313.182 323.628 316.228 316.229 311.876 312.022V311.877Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4829 15.4769L311.011 311.005C315.654 315.648 323.488 312.311 323.488 305.782V10.254C323.488 6.19176 320.151 3 316.234 3H20.7058C14.1772 3 10.9854 10.8343 15.4829 15.4769Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDfwInnovators);
export default __webpack_public_path__ + "static/media/dfw-Innovators.09d84ad09d64e61878eec599b0ff5aad.svg";
export { ForwardRef as ReactComponent };